import React from "react";
import { useTranslation } from "react-i18next";

export default function QuestionOptions(props) {
  const { t } = useTranslation();
  return (
    <li className="draw-toolbar-icon">
      <span
        className={`button normal-btn main-button ${
          props.activeButton === "question-options" ? "active" : ""
        }${props.hideButton ? "passive" : ""}`}
        title={t("Question Tools")}
        data-tip={t("Question Tools")}
        onClick={props.onClick}
      >
        <img
          src={require("../../assets/img/svg/tools-question.svg")}
          alt={t("Question Tools")}
        />
      </span>
    </li>
  );
}
